import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';


interface ILeadProps {
    firstName: string,
    lastName: string,
    phoneNumber1: string,
    phoneNumber2: string,
    setLeadStateInputData: (key: string, e: any) => void,
    checkPhone: (type: string) => void,
    customerErrors: any,
    errors: any,
    number: number,
    doubleLeadWarning: any,
    subContact: (index: number) => void,

}

const AddContactDetails: React.FC<ILeadProps> = ({ firstName, lastName, phoneNumber1, phoneNumber2, setLeadStateInputData, checkPhone, customerErrors, errors, number, doubleLeadWarning, subContact }) => {


    return (

        <div className="parameter-row">
            <div className={`parameter-item ${customerErrors[`firstName${number}`] ? 'error' : ''}`}>
                <div className="field">
                    <div className="title">
                        שם פרטי
                    </div>
                    <div className="value">
                        <input type="text" onChange={(e: any) => setLeadStateInputData(`firstName${number}`, e)} value={firstName} />
                    </div>
                    <div className='error-message'>
                        *{errors.requiredField}
                    </div>
                </div>
            </div>
            <div className={`parameter-item ${customerErrors[`firstName${number}`] ? 'error' : ''}`}>
                <div className="field">
                    <div className="title">
                        שם משפחה
                    </div>
                    <div className="value">
                        <input type="text" onChange={(e: any) => setLeadStateInputData(`lastName${number}`, e)} value={lastName} />
                    </div>
                    <div className='error-message'>
                        *{errors.requiredField}
                    </div>
                </div>
            </div>
            <div className={`parameter-item ${customerErrors[`phoneNumber1${number}`] ? 'error' : ''}`}>
                <div className="field">
                    <div className="title">
                        טלפון נייד
                    </div>
                    <div className="value">
                        <input type="text" onBlur={() => checkPhone('mobile')} maxLength={10} onChange={(e: any) => setLeadStateInputData(`phoneNumber1${number}`, e)} value={phoneNumber1} />
                    </div>
                    <div className='error-message'>
                        {
                            !phoneNumber1 || phoneNumber1 == '' ?
                                (<>
                                    *{errors.requiredField}
                                </>) :
                                (<>
                                    *{errors.invalidMobilePhoneNumber}
                                </>)
                        }
                    </div>
                    <div className={`${doubleLeadWarning.mobile ? 'warning-message' : 'hide'}`}>
                        *{errors.doubleLeadWarning}
                    </div>
                </div>
            </div>
            <div className={`parameter-item ${customerErrors[`phoneNumber2${number}`] ? 'error' : ''}`}>
                <div className="field">
                    <div className="title">
                        טלפון נוסף
                    </div>
                    <div className="value">
                        <input type="text" onBlur={() => checkPhone('phone')} maxLength={10} onChange={(e: any) => setLeadStateInputData(`phoneNumber2${number}`, e)} value={phoneNumber2} />
                    </div>
                    <div className='error-message'>
                        *{errors.invalidPhoneNumber}
                    </div>
                </div>
            </div>



            <DeleteOutlined
                style={{
                    fontSize: '28px',
                    marginLeft: '20px',
                    color: 'rgb(24, 108, 199)',
                    marginTop: '35px'
                }}
                onClick={() => subContact(number)} />
        </div>
    )
}

export default AddContactDetails